import { QrCodePix } from "qrcode-pix";

export default async function geraPix(
  key,
  name,
  city,
  transactionId,
  message,
  cep,
  value,
) {
  console.log(key, name, city, transactionId, message, cep, value);

  const dados = {
    version: "01",
    key: key, //or any PIX key
    name: name,
    city: city,
    transactionId: JSON.stringify(transactionId), //max 25 characters
    message: message,
    cep: cep,
    value: value,
  };
  const qrCodePix = QrCodePix(dados);

  return { code: await qrCodePix.base64(), copyLine: qrCodePix.payload() };
}
